import React from 'react';
import { browserHistory } from 'react-router';
import { IconMenuActions } from './IconMenuActions';

const actions: Record<string, unknown> = {
  edit: 'Edit patient',
  chat: 'Chat with the patient',
  merge: 'Merge patient',
  divider: '',
  appointments: 'See appointments',
  waitlists: 'See waitlists',
  offers: 'See offers',
  reminders: 'See reminders',
};

interface PatientActionsProps {
  item: Record<string, unknown>;
  hideMerge?: boolean;
  onPatientMerge?: Function;
  style?: Record<string, unknown>;
}

class PatientActions extends React.PureComponent<PatientActionsProps> {
  constructor(props: PatientActionsProps) {
    super(props);

    this.onAction = this.onAction.bind(this);
  }

  onAction(key: string) {
    const { item, onPatientMerge } = this.props;

    if (key === 'merge' && onPatientMerge) {
      onPatientMerge(item);
    } else {
      browserHistory.push(`/patients/${item._id}/${key}`);
    }
  }

  render() {
    const { hideMerge, style } = this.props;

    if (hideMerge) delete actions.merge;

    // @ts-ignore
    return <IconMenuActions style={style} actions={actions} onAction={this.onAction} />;
  }
}

export default PatientActions;
